import {AvailableDiscountDto} from "../../../apps/subscriptions/shared/model/discount/AvailableDiscountDto";
import {PendingDiscountDto} from "../../../apps/subscriptions/shared/model/discount/PendingDiscountDto";
import {DiscountPresentation} from "../../../apps/subscriptions/shared/model/discount/discount-pricing";


export type CurrencyCode = 'CZK' | 'EUR' | 'USD';
export type SubscriptionLevel = 'zero' | 'basic' | 'advanced';

// DB values confirmed on 2026-09-16. Products currently expose prices, not plan budgets.
// Update here when experimenting with FREE; all displayed ratios derive from these values.
export const UPGRADE_PLAN_BUDGETS = {zero: 2_000_000, basic: 200_000_000, advanced: 500_000_000} as const;

export interface PlanOffer {
    plan: 'basic' | 'advanced';
    pricing: PricingInfo;
    freeLimitMultiple: number;
}

export interface DiscountState {
    available: boolean;
    pending: boolean;
    discount: AvailableDiscountDto | null;
    pendingDiscount: PendingDiscountDto | null;
}

export interface PricingInfo {
    originalPrice: number;
    discountedPrice: number;
    currency: CurrencyCode;
    formattedOriginalPrice: string;
    formattedDiscountedPrice: string;
    hasDiscount: boolean;
    /** How long the discounted price lasts (unit + note keys); `null` without a discount. */
    presentation: DiscountPresentation | null;
}
